/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { TRUSTED_ORIGINS, MESSAGE_EVENTS } from '../constants';

export function notifyEvent(type, params) {
    if (!type) return;

    let messageEvent = MESSAGE_EVENTS[type];
    if (!messageEvent) return;

    const widgetParentTarget = localStorage.getItem('recwidgettarget');

    // This is to preserve backwards compatability. Can eventually be removed once ui-account, ui-camping and ui-cart make it to production.
    const origin =
        widgetParentTarget ||
        (window.location !== window.parent.location
            ? document?.referrer
            : document?.location?.href);

    const trustedOrigin = TRUSTED_ORIGINS.find((localOrigin) =>
        origin.includes(localOrigin)
    );

    if (params) {
        messageEvent = {
            ...messageEvent,
            params,
        };
    }

    if (trustedOrigin) window.parent.postMessage(messageEvent, trustedOrigin);
}
